import { KeyValueFieldArray } from '@/components/key-value-field-array';

interface KeyValuePairCardProps {
  name: string;
  title: string;
  description: string;
  items: { uid?: string; key?: string; value?: string }[];
}

export const KeyValuePairCard = ({ name, title, description, items }: KeyValuePairCardProps) => {
  return (
    <KeyValueFieldArray
      name={name}
      title={title}
      description={description}
      items={items}
      appearance="card"
      addLabel="New key value pair"
    />
  );
};
